"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Query_1 = __importDefault(require("./Query"));
var Base_1 = __importDefault(require("../data/Base"));
var firebase_1 = require("./firebase");
var Version = /** @class */ (function (_super) {
    __extends(Version, _super);
    function Version(orgId, analysisId, queryId, versionId) {
        var _this = _super.call(this, versionId) || this;
        _this.path = function () {
            return _this.query.getPath() + "/versions/" + _this.id;
        };
        _this.getIdsForUser = function (uid) {
            return _this.getByPath("/users_mapping/versions/" + uid);
        };
        _this.getConfig = function (orgId) {
            return _this.getByPath("/versions_config/" + orgId);
        };
        _this.get = function () {
            return _this.getByPath(_this.path());
        };
        _this.getQuery = function () {
            return _this.query;
        };
        _this.getRequest = function () {
            return _this.getByPath(_this.path() + "/request");
        };
        _this.getTranslation = function () {
            return _this.getByPath(_this.path() + "/translation");
        };
        _this.getResult = function () {
            return _this.getByPath(_this.path() + "/result");
        };
        _this.updateVisualization = function (uid, visualization) {
            _this.set(_this.path() + "/audit/updatedAt", firebase_1.dbConstants.ServerValue.TIMESTAMP);
            _this.set(_this.path() + "/audit/updatedBy", uid);
            return _this.set(_this.path() + "/result/selectedVisualization", visualization);
        };
        _this.query = new Query_1.default(orgId, analysisId, queryId);
        return _this;
    }
    return Version;
}(Base_1.default));
exports.default = Version;
//# sourceMappingURL=Version.js.map


//////////////////
// WEBPACK FOOTER
// ../api/lib/data/Version.js
// module id = 878
// module chunks = 8